import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconOverwriteEverything = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeMiterlimit: 1.4,
	clipRule: "evenodd",
	viewBox: "0 0 1024 1024",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M0 0h1024v1024H0z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 9764.31,
			cy: 1778.71,
			r: 236.614,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 62.74,
			transform: "translate(-10857.3 -1529.3)scale(1.14763)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 9764.31,
			cy: 1778.71,
			r: 236.614,
			stroke: "currentColor",
			strokeWidth: 62.74,
			transform: "translate(-10530.3 -1529.3)scale(1.14763)"
		})
	]
});
export default SvgIconOverwriteEverything;
